module.exports = __webpack_public_path__ + "static/warehouse-poster-9f63b62601d5b2f1dea53407f7fc9bf1.jpg";